<template>
  <div class="list-agents-province">
    <el-table
      stripe
      :data="mData.tableRules.data"
      border
      max-height="298"
      style="width: 100%"
      @sort-change="fn_tableSortChange"
      :default-sort="{
        prop: mData.tableRules.defaultSort[0],
        order: mData.tableRules.defaultSort[1],
      }"
    >
      <el-table-column prop="" label="STT" width="50">
        <template slot-scope="scope">
          <div class="text-center">
            {{ mData.tableRules.offset + scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="ten_tinh"
        label="Tỉnh/Thành phố"
        min-width="100"
        :sortable="mData.tableRules.allowSorting"
      >
        <template slot-scope="scope">
          {{ scope.row.ten_tinh }}
          <i
            class="fa-solid fa-badge-check"
            style="color: #409eff"
            v-if="scope.row.chinh_thuc"
          ></i>
          <i
            class="fa-solid fa-badge-check"
            style="color: #878787"
            v-if="!scope.row.chinh_thuc"
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="ten_cap_dai_ly"
        label="Cấp đại lý"
        align="center"
        width="180px"
        :sortable="mData.tableRules.allowSorting"
      >
        <template slot-scope="scope">
          {{ scope.row.ten_cap_dai_ly }}
        </template>
      </el-table-column>
      <el-table-column
        prop="trang_thai"
        label="Trạng thái"
        align="center"
        width="200"
        :sortable="mData.tableRules.allowSorting"
      >
        <template slot-scope="scope">
          <div
            v-if="scope.row.hieu_luc"
            class="status-dai-ly status-dai-ly__active"
          >
            Hoạt động
          </div>
          <div v-else class="status-dai-ly status-dai-ly__disabled">
            Ngừng hợp tác
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Thao tác" align="center" width="160px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            @click="fn_handle('detail', scope.$index, scope.row)"
            v-b-popover.hover.left="aLang.c_detail"
          >
            <i class="fa fa-eye"></i>
          </el-button>
          <el-button
            size="mini"
            plain
            @click="fn_handle('update', scope.$index, scope.row)"
            v-b-popover.hover.left="aLang.c_update"
            type="primary"
          >
            <i class="far fa-edit"></i>
          </el-button>

          <!-- @click="fn_handle('stop', scope.$index, scope.row)" licensing-->
          <el-button
            size="mini"
            plain
            @click="fn_showAuthenticationUpdateStatus('stop', scope.row)"
            v-b-popover.hover.left="aLang.c_stop"
            v-if="scope.row.hieu_luc"
            type="danger"
          >
            <i class="far fa-ban"></i>
          </el-button>
          <el-button
            size="mini"
            plain
            @click="fn_showAuthenticationUpdateStatus('licensing', scope.row)"
            v-b-popover.hover.left="aLang.c_licensing"
            v-if="!scope.row.hieu_luc"
            type="success"
          >
            <i class="far fa-circle-check"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="btn-add-agent-province">
      <el-button
        type="success"
        @click="fn_themDaiLyTinh()"
        :disabled="statusAgent !== 'hoat_dong' || disabled || createFullAgentProvince"
      >
        <i class="fa-solid fa-circle-plus" style="margin-right: 5px" />
        Thêm đại lý tỉnh
      </el-button>
    </div>
    <Authentication
      v-if="isCapNhatDaiLyCapTinh"
      :action="'update_status'"
      :idAgent="idAgent"
      @update_status="updateStatusAgent"
      @close_dialog="isCapNhatDaiLyCapTinh = false"
    ></Authentication>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "@/service/LanguageService";
import MethodService from "@/service/MethodService";
import DataForm from "@/dataForm/dataFormDaiLyTinh";
import mushroom from "viettoc-api";
import Authentication from "@/component/Authentication";

export default {
  props: {
    statusAgent: String,
    idDaiLy: String,
    disabled: Boolean,
  },
  data() {
    return {
      loading: true,
      aLang: LanguageService.lang,
      isCapNhatDaiLyCapTinh: false,
      idAgent: "", // id của đại lý tỉnh
      statusUpdateAgent: undefined,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
      listProvinces: [],
      createFullAgentProvince: false
    };
  },
  components: {
    Circle4,
    Authentication,
  },
  methods: {
    fn_showAuthenticationUpdateStatus(status, row) {
      this.isCapNhatDaiLyCapTinh = true;
      this.idAgent = row.id;
      if (status === "stop") {
        this.statusUpdateAgent = false;
      } else this.statusUpdateAgent = true;
    },
    async updateStatusAgent() {
      this.isCapNhatDaiLyCapTinh = false;
      await this.updateStatusDaiLyTinh(this.idAgent, this.statusUpdateAgent);
      await this.fn_initTable();
    },
    async getListIdTinh() {
      try {
        const response = await mushroom.province.getAllAsync()
        this.listProvinces = response.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: ["dai_ly_id=" + this.idDaiLy],
        fields: this.mData.tableRules.fields,
        limit: 100,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      try {
        const response = await mushroom.agt_dai_ly_tinh.getAllAsync(dataFilter);
        if (response.result && response.result.length > 0) {
          const res = await this.changeData(response.result);
          this.mData.tableRules.data = res;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
        }
      } catch (e) {
        MethodService.showError(e.code);
      } finally {
        this.loading = false;
      }
    },
    async changeData(data) {
      data.forEach(async (item) => {
        item.ten_tinh = "";
        item.ten_cap_dai_ly = "";
        item.ten_tinh = await this.renderTenTinh(item.tinh_id);
        item.ten_cap_dai_ly = await this.renderTenCapDaiLy(item.cap_id);
      });
      // await this.getAllSanPham();
      return data;
    },
    async getAllSanPham() {
      try {
        const response = await mushroom.prd_san_pham.getAllAsync({
          fields:
            "id,ten,ma_sp,mo_ta_ngan,mo_ta,khoi_tao,goi_dich_vu_id,gia_han,gia_niem_yet,dai_ly_ban,phu_kien,san_pham_cha_ids",
          filters: ["dai_ly_ban=true", "hieu_luc=true"],
          sort: "ten",
          limit: 100,
        });
        console.log("Các prd_san_pham thỏa mãn: %o", response);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async renderTenTinh(id) {
      try {
        const response = await mushroom.province.findByIdAsync({
          id: id,
          fields: "name,type",
        });
        if (!response.result) return "";
        return response.result.type + " " + response.result.name;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async renderTenCapDaiLy(id) {
      try {
        const response = await mushroom.agt_cap.findByIdAsync({
          id: id,
          fields: "ten",
        });
        if (!response.result) return "";
        return response.result.ten;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    fn_themDaiLyTinh() {
      this.$emit("add-agent-province");
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    async getThongTinDaiLyTinh(id) {
      try {
        const response = await mushroom.agt_dai_ly_tinh.findByIdAsync({
          id: id,
        });
        let arr = [];
        if (response.result) arr.push(response.result);
        console.log("đại lý tỉnh khi bấm xem", id, response.result);
        const res = await this.changeData(arr);
        this.$emit("data-agent-province", res);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async fn_handle(type, scope, row) {
      if (type == "detail") {
        await this.getThongTinDaiLyTinh(row.id);
        this.$emit("detail-agent-province");
      }
      if (type == "update") {
        await this.getThongTinDaiLyTinh(row.id);
        this.$emit("update-agent-province");
      }
    },
    async updateStatusDaiLyTinh(id, status) {
      const agt_dai_ly_tinh_object = {
        id: id,
        hieu_luc: status,
      };
      try {
        const response = await mushroom.agt_dai_ly_tinh.partialUpdateAsync(
          agt_dai_ly_tinh_object
        );
        if (response.result == id) {
          window.toastr.success("Cập nhật trạng thái đại lý tỉnh thành công");
        } else window.toastr.warning("Dữ liệu không thay đổi");
      } catch (e) {
        MethodService.showError(e.code);
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_renderTypeAgent(type) {
      switch (type) {
        case "doanh_nghiep":
          return `<div class="type-agent type-agent__doanh-nghiep">Doanh nghiệp</div>`;
        case "ca_nhan":
          return `<div class="type-agent type-agent__ca-nhan">Cá nhân</div>`;
        default:
          return "";
      }
    },
    fn_renderStatusAgent(status) {
      switch (status) {
        case "cho_duyet":
          return `<div class="status__waiting">Chờ duyệt</div>`;
        case "hoat_dong":
          return `<div class="status__active">Hoạt động</div>`;
        case "ngung_hop_tac":
          return `<div class="status__hold">Ngừng hợp tác</div>`;
        case "huy":
          return `<div class="status__cancel">Hủy</div>`;
        default:
          return "";
      }
    },
  },

  async mounted() {
    await this.fn_initTable();
    await this.getListIdTinh();
  },
  watch: {
    listProvinces(oldValue, newValue) {
      console.log('this.listProvinces.length', this.listProvinces.length)
      console.log('this.mData.tableRules.data.length', this.mData.tableRules.data.length)
      if (this.mData.tableRules.data.length >= this.listProvinces.length) this.createFullAgentProvince = true
    },
  }
};
</script>
<style scoped lang="scss">
.btn-add-agent-province {
  text-align: end;
  margin: 10px 0 0 10px;
}
.list-agents-province {
  margin-top: 15px;
}
.status-dai-ly {
  width: fit-content;
  margin: auto;
  padding: 0 10px;
  border-radius: 7px;
  &__active {
    color: #62b438;
    background-color: rgba(98, 180, 56, 0.18);
  }
  &__disabled {
    color: #909399;
    background-color: #f4f4f5;
  }
}
</style>
